var configs = {
    clear: false,
    form: false,
    input: false,
    submit: false
};
export default configs;



//////////////////
// WEBPACK FOOTER
// /Users/emmanuelpiguet/Documents/Web/Local/icmc/app/public/wp-content/themes/icmc/node_modules/mmenu-js/dist/addons/searchfield/_configs.js
// module id = 79
// module chunks = 0